import { useV2CreateServiceAccountCredentialMutation } from "@generated";
import { ClientCredential } from "../types";

interface CreateInput {
  userId: number;
  name: string;
  redirectUri?: string;
}

const useCreateClientCredential = () => {
  const [trigger, { isLoading }] =
    useV2CreateServiceAccountCredentialMutation();

  const createCredential = async (
    input: CreateInput
  ): Promise<ClientCredential> => {
    const result = await trigger({
      userId: input.userId,
      body: {
        data: {
          type: "service-account-credentials",
          attributes: {
            name: input.name,
            "redirect-uri": input.redirectUri ?? "",
          },
        },
      },
    }).unwrap();

    const row = result.data;
    return {
      id: Number(row?.id ?? 0),
      name: row?.attributes.name ?? "",
      redirectUri: row?.attributes["redirect-uri"] ?? "",
      clientId: row?.attributes["client-id"] ?? "",
      clientSecret: row?.attributes["client-secret"] ?? "",
    };
  };

  return { createCredential, isCreating: isLoading };
};

export default useCreateClientCredential;
